import {
    Box,
    Typography,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

// Read-only Ansicht einer Übung (gruppierte Sätze + optionale Notizen).
function ExerciseAccordion({ exerciseName, exercise, defaultExpanded }) {
    return (
        <Accordion
            defaultExpanded={defaultExpanded}
            sx={{
                background: 'linear-gradient(145deg, #1e293b 0%, #0f172a 100%)',
                border: '1px solid rgba(59, 130, 246, 0.3)',
                borderRadius: '16px !important',
                '&:before': { display: 'none' },
                '&.Mui-expanded': { margin: 0 },
            }}
        >
            <AccordionSummary
                expandIcon={<ExpandMoreIcon sx={{ color: '#3b82f6' }} />}
                sx={{
                    background: 'rgba(59, 130, 246, 0.1)',
                    '&:hover': { background: 'rgba(59, 130, 246, 0.15)' },
                    py: 1.5,
                }}
            >
                <Box sx={{ flex: 1 }}>
                    <Typography fontWeight={700} color="#e0f2fe" sx={{ mb: 0.5 }}>
                        {exerciseName}
                    </Typography>
                    <Typography variant="caption" color="#64748b">
                        {exercise.saetze.length} Satz{exercise.saetze.length !== 1 ? 'e' : ''}
                    </Typography>
                </Box>
            </AccordionSummary>

            <AccordionDetails sx={{ pt: 2, pb: 2 }}>
                <TableContainer>
                    <Table size="small" sx={{ mb: 1 }}>
                        <TableHead>
                            <TableRow sx={{ background: 'rgba(59, 130, 246, 0.1)' }}>
                                <TableCell sx={{ color: '#93c5fd', fontWeight: 700, fontSize: '0.75rem' }}>Satz</TableCell>
                                <TableCell sx={{ color: '#93c5fd', fontWeight: 700, fontSize: '0.75rem' }}>Wdh.</TableCell>
                                <TableCell sx={{ color: '#93c5fd', fontWeight: 700, fontSize: '0.75rem' }}>Gewicht</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {exercise.saetze.map((set, setIndex) => (
                                <TableRow key={setIndex}>
                                    <TableCell sx={{ color: '#e0f2fe', fontWeight: 600, py: 1 }}>{set.satz_nummer}</TableCell>
                                    <TableCell sx={{ color: '#e0f2fe', fontWeight: 600, py: 1 }}>{set.wiederholungen}</TableCell>
                                    <TableCell sx={{ color: '#e0f2fe', fontWeight: 600, py: 1 }}>
                                        {set.gewicht_kg ? `${set.gewicht_kg} kg` : '–'}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>

                {exercise.saetze.some(s => s.notizen) && (
                    <Box sx={{ mt: 2, pt: 2, borderTop: '1px solid rgba(59, 130, 246, 0.2)' }}>
                        <Typography variant="caption" color="#93c5fd" sx={{ fontWeight: 600, display: 'block', mb: 1 }}>
                            Notizen
                        </Typography>
                        {exercise.saetze.map((set, idx) => (
                            set.notizen && (
                                <Typography key={idx} variant="caption" color="#cbd5e1" sx={{ display: 'block', mb: 0.5 }}>
                                    <strong>Satz {set.satz_nummer}:</strong> {set.notizen}
                                </Typography>
                            )
                        ))}
                    </Box>
                )}
            </AccordionDetails>
        </Accordion>
    );
}

export default ExerciseAccordion;
